import DataMutations from '../graphql/Mutations';
import DataQueries   from '../graphql/Queries';
import mainPageModel from '../main-navigation/MainPageModel';
import DocumentDialogModel, {
  DocumentSchema
} from './DocumentDialogModel';


export class OccupationDialogModel extends DocumentDialogModel {
  constructor() {
    super(
      'Occupation',
      (ids: string[]) => DataQueries.getOccupationsByIds(DocumentSchema, ids),
      DataMutations.insertOccupations,
      DataMutations.updateOccupations,
      DataMutations.deleteOccupations,
      'occupations',
      () => mainPageModel.canAddOccupations,
      () => mainPageModel.canEditOccupations,
      () => mainPageModel.canDeleteOccupations,
    );
  }
}

const occupationDialogModel = new OccupationDialogModel();
export default occupationDialogModel;
